import JSEncrypt from 'jsencrypt'
let encrypt = new JSEncrypt()
let rsaKey =
	'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChU3W7TJzRcdcSt5BqD3mybuNETfwtqtCjqVQXXtI1lzjAg+Xd6TUvMYuhmHbUwP8itu1CvlPihqUzQEpnfodE48aEUZ5ybX2ZTUoiq94UcqIm4rV5hv7m8voiWes6N6iC3znGII6wgQSpV9GQA6bj16G1VeS4l1hQuoOyuqGWmwIDAQAB'
encrypt.setPublicKey(rsaKey)
const rsaKeyUtil = {}
rsaKeyUtil.encrypt = function (val) {
	return encrypt.encrypt(val)
}
export default rsaKeyUtil
